module.exports = __webpack_public_path__ + "img/luntan_2018_03.e7622806.jpg";